export default {
      id: "share-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.1792148661250.svg#share-usage",
      toString: function () {
        return this.url;
      }
    }